var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.lang),function(language){return _c('li',{key:language,on:{"click":function($event){return _vm.switchLang(language)}}},[_vm._v(" "+_vm._s(language)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }